import { type ClickModifiers, isPlainLeftClick } from "../../clicks";

export interface FooterLink {
  label: string;
  href: string;
  /** Opens in a new tab (another site); otherwise it is a route of the suite. */
  external?: boolean;
}

/** A plain left click on a suite route is followed in the app, without reloading the page. */
export function followsInApp(link: FooterLink, click: ClickModifiers): boolean {
  return !link.external && isPlainLeftClick(click);
}

/** External links open in a new tab, without access to this page. */
export function externalLinkProps(link: FooterLink): { target?: string; rel?: string } {
  return link.external ? { target: "_blank", rel: "noopener noreferrer" } : {};
}

export function copyright(company: string, year: number): string {
  return `© ${year} ${company}`;
}
